import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SupportDocumentTypesByLifeEvent } from "../enums/sep-application-review-grid.enum";
import { ExistingDocs } from "src/app/angular-elements/form-wrappers/form-components/required-docs-upload/interfaces/displayable-file.interface";
import { SepApplicationReviewDashboardService } from "../../services/sep-application-review-dashboard.service";
import { FileDisplayComponent } from "src/app/angular-elements/form-wrappers/form-components/required-docs-upload/file-display/file-display.component";
import { EnrollPayloadRequest } from "src/app/angular-elements/shared/interfaces/enrollment-submission.interface";
import { ModalArgs } from "../interfaces/sep-application-review.document-upload-modal.interface";

@Component({
  selector: "app-upload-documents-modal",
  templateUrl: "./upload-documents-modal.component.html",
  styleUrl: "./upload-documents-modal.component.scss",
  standalone: false
})
export class UploadDocumentsModalComponent implements OnInit {

  singleDocumentControlNumber: string;

  constructor(
    private sepApplicationReviewDashboardService: SepApplicationReviewDashboardService,
    @Inject(MAT_DIALOG_DATA) public data: ModalArgs
  ){}

  individualAllowedExtensions = [
    //image types
    '.png',
    '.jpeg',
    '.jpg',
    //document types
    '.doc',
    '.docx',
    '.pdf'
  ]
  
  customDocumentTableConfigs = {
    formNameValue: "ENROLLSEP", // Passed along with payload to indicate type of document ( backend uses to organize files )
    customDropdownSelection: {
      attributeName: 'documentDescription',
      attributeHeader: 'Supporting Document Type',
      values: [],
      requireAllDropdownsToHaveUniqueSelection: false,
      disableRemoveButtonOnSuccess: true
    }, // This allows the uesr to select a formNameValue
    minDocuments: 0,
    maxDocuments: 10,
    editorName: this.data.editorName ?? null
  }

  existingDocs: ExistingDocs[];

  async ngOnInit(): Promise<void> {

    this.existingDocs = this.data?.existingDocs ? this.data.existingDocs : null;

    const upperKey = this.data.appData.lifeEvent.toUpperCase();
    if(SupportDocumentTypesByLifeEvent[upperKey]){
      this.customDocumentTableConfigs.customDropdownSelection.values = [...SupportDocumentTypesByLifeEvent[upperKey]];
    }
    else{
      this.customDocumentTableConfigs.customDropdownSelection.values = [...SupportDocumentTypesByLifeEvent.DEFAULT_OTHER];
    }
    
    // Fetch enrollment object
    const enrollmentObj: EnrollPayloadRequest
      = await this.sepApplicationReviewDashboardService.fetchEnrollmentObjectByAppId(this.data.appData.applicationNumber);

    // Narrow to existing documents
    const existingDocuments = enrollmentObj.enrollment.sepInformation?.documentcontrolnumber;
    
    // MN should return only a single, merged set of documents
    if (existingDocuments.length === 1) {
      this.singleDocumentControlNumber = existingDocuments[0].documentcontrolnumber;
    }
  }

  checkUploadedDocuments(){
    //add a check for documents that were added but not uploaded and throw an error to user if they haven't uploaded all their added documents
  }

  onUploadFile() {
    /**
     * return () => // this is undefined
     * return function () {} // this is where the function is called
     * return (() => // this is HERE ).bind(this)
     */
    return (async (fileComponent: FileDisplayComponent) => {
      const newDocumentArray = [...this.data.appData.documents.files, fileComponent.displayableFileObj]
      await this.sepApplicationReviewDashboardService.postDocumentUpload(newDocumentArray, this.data.appParams, this.data.appData, this.data.appGridApi);
    }).bind(this);
  }
}
          